/* global twttr, gapi */
import {$, _, Backbone} from "backboneAdapter";
import {equals} from "../utils/predicates";
import Handlebars from 'handlebars';
import ServiceGenericView from 'js/views/service.generic.view';
import UserModel from 'js/models/userrelatedinfo.model';
import Template from 'js/templates/service.hbs';
import ComponentModel from 'js/models/component.model';
import ComponentsTemplate from 'js/templates/components.hbs';
import ComponentPreviewTemplate from 'js/templates/components.preview.hbs';
import i18n from 'l10n';
import ServiceReportView from 'js/views/service.report.view';
import Optional from 'optional-js';
import dhtmlx from 'dhtmlxAdapter';
import {on, once, template} from "../adapters/backbone-decorators";
import QRCode from "qrcode";

require('twitter');
require('gapi');

const socialShareTemplate = Handlebars.compile(Handlebars.partials.socialButtonsShare);
const socialFollowTemplate = Handlebars.compile(Handlebars.partials.socialButtonsFollow);
const componentRowTemplate = Handlebars.compile(Handlebars.partials.component);
const componentsTemplate = Handlebars.compile(ComponentsTemplate, {preventIndent: true});
const componentPreviewTemplate = Handlebars.compile(ComponentPreviewTemplate);

@template(Template, {preventIndent: true})
class ServiceView extends ServiceGenericView {
    @on("mouseenter .toggleQuestionComponentInfo")
    enterComponent(e) {
        this.toggleBorderColorOfElement($(e.currentTarget), "#f80");
    }

    @on("mouseleave .toggleQuestionComponentInfo")
    leaveComponent(e) {
        this.toggleBorderColorOfElement($(e.currentTarget), "transparent");
    }

    @on('click .surveyComponentCloseButton')
    clickComponentClose(e) {
        e.stopPropagation();
        this.showHideComponentInfo($(e.currentTarget), "hide");
    }

    @on('click .toggleQuestionComponentInfo')
    clickComponent(e) {
        e.stopPropagation();
        this.showHideComponentInfo($(e.currentTarget), "show");
    }

    @on('mouseenter #execute-send')
    enterExecute() {
        this.validateCondition(this);
    }

    questionsCnt = 0;
    socialShareTemplate = socialShareTemplate;
    socialFollowTemplate = socialFollowTemplate;
    ComponentRowTemplate = componentRowTemplate;
    ComponentsTemplate = componentsTemplate;
    componentPreviewTemplate = componentPreviewTemplate;
    draggingCustomBgImage = false;
    invalidFieldName = null;
    lastOpenedComponentConfig = null;
    questionTypes = ["SurveyStarRating", "SurveyFreeText", "SurveyDate", "SurveyMultipleChoice"];

    @once()
    async autoCompleteFollowUrls() {
        try {
            const data = await $.ajaxDefaultQ({
                url: "/CampaignCloud/Config/socialFollowUrls",
                type: 'GET',
                contentType: "application/json",
                dataType: 'json'
            });

            return _.reduce(data, function (acc, curr) {
                acc[curr._id] = curr.url;
                return acc;
            }, {});

        } catch (e) {
            console.log(e);
            return {};
        }
    }

    isQuestion(component) {
        return this.questionTypes.includes(component);
    }

    constructor(isPostPaid, model) {
        super(isPostPaid, model);
        model.postPaidPrefix = isPostPaid ? "w" : "";
        const campaignTemplateType = model.get("campaignTemplateType");
        switch (campaignTemplateType) {
            case "TELLODY_SURVEY" :
                this.serviceType = "Survey";
                break;
            case "INSTANT_WIN" :
                this.serviceType = "InstantWin";
                break;
            case "EMAIL_OPTIN" :
                this.serviceType = "Optin";
                break;
            case "QUIZ_OPTIN" :
                this.serviceType = "Quiz";
                break;
            case "PAY_PAL_PAYMENT" :
                this.serviceType = "PayPalPayment";
                break;
        }
        this.isSweepstakes = campaignTemplateType === "INSTANT_WIN"
            && Optional.ofNullable(model.get("instantWinPageConfig"))
                .flatMap(m => Optional.ofNullable(m.get("type")))
                .filter(equals("USER_METRICS"))
                .isPresent();
        this.fillInComponentCollection();
    }

    async render() {
        if (!this.qCollection) return this;
        this.questionsCnt = _.reduce(this.qCollection.models, (memo, item) => this.isQuestion(item.get("type")) ? memo + 1 : memo, 0);
        super.render();
        let campaignId = this.model.get('campaignId');

        this.validateCondition(this);

        if (this.isConfigured()) {
            this.serviceReport = new ServiceReportView({
                serviceId: campaignId,
                title: this.model.get('title'),
                components: this.qCollection.models,
                serviceType: this.serviceType,
                isSweepstakes: this.isSweepstakes,
                campaignStatus: this.model.get("campaignStatus"),
                qCollection: this.qCollection,
                isPostPaid: this.isPostPaid,
                startDate: this.model.get('startDate')
            });
        }
        let $messages = $("#messages-configuration").find(".edit");
        const s = $($messages[0]).text().toString();
        if (parseInt(s) === 0) {
            $($messages[0]).text(1);
        }

        try {
            this.customFields = await $.ajaxDefaultQ({
                url: '/CampaignCloud/CustomFields'
            });
            this.showComponents();
            if (!campaignId && this.serviceType === "PayPalPayment")
                this.showPaymentOption();
            if (campaignId && this.serviceType === "Survey")
                this.setSurveyScore();

            this.refreshPreview();
            this.validateCondition(this);

            this.$("#componentsSurface").find('.edit').each((i, e) => {
                this.makeEditable(i, e, this);
            });

            this.setServiceStatus();

            $("#composeMessage").unbind("click").on("click", this.toggleMessageButtonsVisibility);
            if (!this.isConfigured()) {
                $("[id^=mc-answers-]").on("mouseenter", _.bind(this.sortableMCanswers, this));
            }
            this.calculateBigTexts(null);
            this.renderSocialWidgets();
            if (campaignId && this.serviceType !== "Survey") {
                this.getFacebookShareCount($('#optinLink').text().trim());
            }

        } catch (e) {
            console.log(e);
        }
        return this;
    }

    async loadUser(callback) {
        this.userModel = new UserModel();
        await this.userModel.fetch();
        if (callback) callback();
    }

    @on("mouseenter .sortableComponents")
    sortableComponents(e) {
        e.stopPropagation();
        $(".sortableComponents").sortable({
            handle: ".handle",
            containment: "parent",

            start: (event, ui) => {
                this.sortableStartIndex = ui.item.index();
            },
            stop: async (event, ui) => {
                try {
                    if (this.model.hasChanged())
                        await this.model.batchUpdate();

                    const startIndex = this.sortableStartIndex;
                    delete this.sortableStartIndex;
                    const endIndex = ui.item.index();
                    const sortedComponents = this.qCollection.models;
                    const movedComp = sortedComponents.splice(startIndex, 1)[0];
                    sortedComponents.splice(endIndex, 0, movedComp);

                    const response = await $.ajaxDefaultQ({
                        url: `/CampaignCloud/Config/${this.model.get("id")}/surveyPageConfig.components/MOVE/${startIndex}/${endIndex}`,
                        type: 'POST',
                        dataType: "json"
                    });
                    if (response.outcome !== "OK")
                        throw response;

                    this.qCollection.set(sortedComponents);

                    const first = Math.min(startIndex, endIndex),
                        last = Math.max(startIndex, endIndex);
                    const $comps = $("#componentRows").find(".questionLi");
                    _.range(first, last).map(i =>
                        _.extend({
                            cind: i,
                            campaignId: this.model.get("campaignId"),
                            campaignTemplateType: this.model.get("campaignTemplateType"),
                            userId: this.model.get("userId"),
                            postPaidPrefix: this.isPostPaid ? "w" : "",
                            endDate: this.model.get("endDate")
                        }, this.qCollection.at(i).attributes))
                        .forEach(model =>
                            $($comps.get(model.cind)).replaceWith(this.ComponentRowTemplate(model)));

                    this.refreshPreview();
                    this.rewireEvents({low: first, high: last});
                    this.hideFields(this);
                } catch (e) {
                    console.info(e);
                    $.Notify.error("An error occurred!");
                    $(".sortableComponents").sortable("cancel");
                }

            }
        });
    }

    toggleMessageButtonsVisibility() {
        let $e = $("#sendmessagefloatingbutton");
        $e.toggle();
    }

    sortableMCanswers(e) {
        e.stopPropagation();
        let target = e.currentTarget;

        const boundStopLambda = async (event, ui, questionIndex) => {
            try {
                if (this.model.hasChanged()) await this.model.batchUpdate();

                let startIndex = this.sortableMCStartIndex;
                delete this.sortableMCStartIndex;
                let endIndex = ui.item.index();
                if (startIndex === endIndex) return;
                let sortedMCAnswers = this.qCollection.models[questionIndex].get("choices");
                let movedComp = sortedMCAnswers.splice(startIndex, 1)[0];
                sortedMCAnswers.splice(endIndex, 0, movedComp);

                try {
                    const response = await $.ajaxDefaultQ({
                        url: `/CampaignCloud/Config/${this.model.get("id")}/surveyPageConfig.components[${questionIndex}].choices/MOVE/${startIndex}/${endIndex}`,
                        type: 'POST',
                        contentType: "application/json",
                        dataType: "json"
                    });
                    if (response.outcome !== "OK") throw response;
                    this.qCollection.at(questionIndex).set("choices", sortedMCAnswers);
                    let params = _.extend({
                        cind: questionIndex,
                        campaignId: this.model.get("campaignId"),
                        campaignTemplateType: this.model.get("campaignTemplateType"),
                        userId: this.model.get("userId"),
                        postPaidPrefix: this.isPostPaid ? "w" : "",
                        endDate: this.model.get("endDate")
                    }, this.qCollection.at(questionIndex).attributes);
                    $(`#component-${questionIndex}`).replaceWith(this.ComponentRowTemplate(params));
                    this.refreshPreview();
                    this.rewireEvents({low: questionIndex, high: questionIndex});

                } catch (e) {
                    console.info(e);
                    $.Notify.error(i18n.t("generic.=Error"));
                    $(target).sortable("cancel");
                }
            } catch (err) {
                console.log(err);
                $.Notify.error(i18n.t("generic.=Error"));
            }
        };

        $(target).sortable({
            containment: "parent",
            items: ".choice",
            start: (event, ui) => {
                this.sortableMCStartIndex = ui.item.index();
            },

            stop: async function (event, ui) {
                const questionIndex = $(this).attr("data-index");
                await boundStopLambda(event, ui, questionIndex);
            }
        });
    }

    toggleCurrentComponentInfo(element, type) {
        if (element.length === 0) return;
        let parent = element.parent();
        let questionIndex = parent.data("cid");
        let elemToggle = $(".surveyquestionfloatingbutton" + questionIndex);
        let elemToggleShadow = $(".surveyquestionfloatingshadow" + questionIndex);

        switch (type) {
            case "show":
                this.toggleVisibilityOfElement(elemToggle, "block");
                this.toggleShadowOfElement(elemToggleShadow, "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px, rgb(0, 0, 0) 0px 6px 20px 0px");
                break;
            case "hide":
                this.toggleVisibilityOfElement(elemToggle, "none");
                this.toggleShadowOfElement(elemToggleShadow, "0 0 0 0 #232323");

                break;
            default:
                console.info("Wrong Type of component's toggle functionality!");
        }

    }

    toggleVisibilityOfElement(element, display) {
        if (display === "toggle") {
            $(element).toggle();
        } else { //e.g. "display: none, block
            $(element).css("display", display);
        }
    }

    toggleShadowOfElement(element, shadow) {
        $(element).css("box-shadow", shadow);
    }

    toggleBorderColorOfElement(element, border) {
        let parent = element.parent();
        let questionIndex = parent.data("cid");
        let elemToggleBorder = $(".surveyquestionborder" + questionIndex);
        $(elemToggleBorder).css("outline-color", border);
    }

    showComponents() {
        let templateParams = {
            components: this.qCollection.models,
            campaignId: this.model.get("campaignId"),
            campaignTemplateType: this.model.get("campaignTemplateType"),
            userId: this.model.get("userId"),
            postPaidPrefix: this.model.uurlPrefix,
            endDate: this.model.get("endDate"),
            description: this.model.get("description"),
            customFields: this.customFields
        };
        $("#componentsSurface").html(this.ComponentsTemplate(templateParams));
        this.setPolicyText();
        this.hideFields(this);
    }

    rewireEvents(bounds) {
        let compRows = this.$(".questionLi");
        if (bounds) {
            compRows = compRows.filter(i => i >= bounds.low && i <= bounds.high);
        }
        compRows.find('.edit').each((i, e) => {
            this.makeEditable(i, e, this);
        });
        this.$("[id^=mc-answers-]").off().on("mouseenter", _.bind(this.sortableMCanswers, this));
        this.renderSocialWidgets();
    }

    fillInComponentCollection() {
        this.qCollection = this.model.get("surveyPageConfig").get("components");
    }

    async fetchAutoCompletionFor(network) {
        return (await this.autoCompleteFollowUrls())[network];
    }

    setPolicyText() {
        const actualSetPolicyText = (policyText) => {
            if (!policyText) {
                policyText = 'https://www.tellody.com/privacy-policy';
            }
            this.policyText = policyText;
            const policyLabel = $(`<text>${i18n.t('service.privacypolicy')}</text>`);
            policyLabel.find('a').attr('href', policyText);
            this.$el.find('#privacy-policy, #privacy-policy-preview')
                .find('h5')
                .find('span')
                .html(policyLabel.html());
        };
        if (!this.policyText) {
            $.getDefaultQ('/CampaignCloud/CompanyDetails/privacyPolicyURL').done(actualSetPolicyText);
        } else {
            actualSetPolicyText(this.policyText);
        }
    }

    async load() {
        await this.loadUser();
        await this.render();
    }

    showPaymentOption() {
        let $pm = $("[id^=paymentMethod]");
        if ($pm.length === 0) return;
        Backbone.$.get('/CampaignCloud/oauthClient/paypal/merchantId').always((data, status) => {
            if (status === "success" && data) {
                const pp = `<h2 class="fg-funkyOrange"><i class="icon-paypal no-margin bg-funkyOrange serviceiconverysmall fg-white "></i>&nbsp;${i18n.t('permissions.paypal')}</h2>`;
                $pm.html(pp);
            } else {
                const pm = `<h3 class="fg-red">${i18n.t('paymentMethodMissing')}</h3><button class="configPaymentMethod">${i18n.t('configure')}</button>`;
                $pm.html(pm);
                $(".configPaymentMethod").click(function () {
                    location.href = "Profile.htm#manage-permissions";
                });
                this.noConfiguredPaymentMethod = true;
            }
        });

    }

    @on('click #create-buyers-group')
    async createBuyersGroup() {
        let campaignId = this.model.get("campaignId");
        let service = "payPalPayment";
        let title = ".newBuyersGroup";
        let query = `in payPalPaymentBuyers(${campaignId})`;
        let text = i18n.t("createBuyersGroup");
        const result = await dhtmlx.confirm({
            text,
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no")
        });
        if (result) {
            this.createGroup(title, query, service);
        }

    }

    updateSharePreview(el) {
        let parentIndex = $(el).data("parent-index");
        let userId = this.model.get("userId");
        let campaignId = this.model.get("campaignId");
        let component = _.extend(this.qCollection.models[parentIndex].attributes, {url: Handlebars.helpers.optinUrl(userId, campaignId, this.isPostPaid ? "w" : "")});
        let shareHtml = this.socialShareTemplate(component);
        $(`#share-buttons-${parentIndex}`).html(shareHtml);
        this.refreshPreview();
        this.renderSocialWidgets();
    }

    updateFollowPreview(el) {
        let parentIndex = $(el).data("parent-index");
        let component = this.qCollection.models[parentIndex];
        let followHtml = this.socialFollowTemplate(component.attributes);
        $(`#follow-buttons-${parentIndex}`).html(followHtml);
        this.refreshPreview();
        this.renderSocialWidgets();
    }

    renderSocialWidgets(widgetType) {
        let twSelector, gpSelector;
        switch (widgetType) {
            case "share":
                twSelector = ".twitter-share-button";
                gpSelector = ".gplus-share-button";
                break;
            case "follow":
                twSelector = ".twitter-follow-button";
                gpSelector = ".g-follow";
                break;
            default:
                twSelector = ".twitter-share-button, .twitter-follow-button";
                gpSelector = ".gplus-share-button, .g-follow";

        }
        $(twSelector).each(function (idx, el) {
            if(twttr)
                twttr.widgets.load(el);
        });
        $(gpSelector).each(function (idx, el) {
            gapi[$(el).hasClass("g-follow") ? "follow" : "plus"].go(el.tagName);
        });
    }

    showHideComponentInfo(elem, type) {
        let correspondingComponent = elem.parent().data("cid");
        if (type === "show") {
            this.lastOpenedComponentConfig = correspondingComponent;
            _.each(this.qCollection.models, (v, k) => {
                if (k !== correspondingComponent) {
                    this.toggleCurrentComponentInfo($(`#component-${k}`).find(".toggleQuestionComponentInfo"), "hide");
                } else if (v.get("type") === "SurveyMultipleChoice" && !v.get("multiple") && v.get("choices").length > 12) {
                    const answersEl = elem.parent().find(`#mc-answers-${correspondingComponent}`);
                    $("#sc-answers-" + correspondingComponent).remove();
                    answersEl.show();
                }
            });
        } else {
            delete this.lastOpenedComponentConfig;
            let thisModel = this.qCollection.models[correspondingComponent];
            if (thisModel.get("type") === "SurveyMultipleChoice" && !thisModel.get("multiple") && thisModel.get("choices").length > 12) {
                let scAns = $(`<div id="sc-answers-${correspondingComponent}" class="questionpadding">`);
                let select = $("<select>");
                _.each(thisModel.get("choices"), (v, k) => {
                    select.append(`<option>${v}</option>`);
                });
                let answersEl = elem.parent().find(`#mc-answers-${correspondingComponent}`);
                scAns.append(select);
                answersEl.before(scAns);
                answersEl.hide();
            }
        }
        this.toggleCurrentComponentInfo(elem, type);
    }

    @on('click #copyToClipboard')
    copyToClipboard() {
        let optinLinkText = $('#optinLink').text().trim();
        let tempTextArea = document.createElement('textarea');
        //BE EXTRA CAREFUL. CHROME CANNOT SELECT WHEN display IS SET TO none
        tempTextArea.style = 'opacity: 0;z-index: 555;position: fixed;';
        document.body.appendChild(tempTextArea);
        tempTextArea.textContent = optinLinkText;
        tempTextArea.select();
        try {
            let successful = document.execCommand('copy');
            let msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
        } catch (err) {
            console.log('Oops, unable to copy');
        }
    }

    getOptinLink() {
        const userId = this.model.get("userId");
        const campaignId = this.model.get("campaignId");
        return encodeURIComponent(`https://${this.model.postPaidPrefix}${userId}.tellody.com/o/${campaignId}`);
    }

    @on('click #qrCode')
    async createQRCode(evt) {
        const $emailOptinQRCode = $("#emailOptinQRCode");
        if ($emailOptinQRCode.attr("src") !== "") {
            $("#emailOptinQRCode").parent().toggle();
            return;
        }

        const link = $(evt.currentTarget).data("link");
        const url = await QRCode.toDataURL(link, {scale: 7});
        $('#qrcode').attr("src", url);
        $emailOptinQRCode.attr("src", url);
        $emailOptinQRCode.parent().show();

    }

    @on('click #facebookShare')
    facebookShare() {
        window.open(`http://www.facebook.com/sharer/sharer.php?u=${this.getOptinLink()}`);
    }

    @on('click #twitterShare')
    twitterShare() {
        const campaignId = this.model.get("campaignId");
        const optinLink = this.getOptinLink();
        const url = 'https://twitter.com/intent/tweet';
        window.open(`${url}?original_referer=${optinLink}&ref_src=twsrc%5Etfw&text=Opt-in%20${campaignId}&tw_p=tweetbutton&url=${optinLink}`);
    }

    refreshStarsPreview(el, size, index) {
        let score = 3;

        let elpreview = $(`#ratingpreview${index} ul`);
        $(elpreview).empty();
        for (let k = 0; k < size; k++) {
            if (score >= k + 1) {
                elpreview.append("<li class='rated'></li>");
                el.append("<li class='rated'></li>");

            } else {
                elpreview.append("<li></li>");
                el.append("<li></li>");
            }
        }

        let $ratingDiv = $(`#rating${index}`);
        let $ratingPreviewDiv = $(`#ratingpreview${index}`);
        if (size > 6 && size < 10) {
            $ratingDiv.removeClass("large");
            $ratingPreviewDiv.removeClass("large");
            $ratingDiv.removeClass("small");
            $ratingPreviewDiv.removeClass("small");
        } else if (size === 10) {
            $ratingDiv.addClass("small");
            $ratingPreviewDiv.addClass("small");
            $ratingDiv.removeClass("large");
            $ratingPreviewDiv.removeClass("large");
        } else {
            $ratingDiv.addClass("large");
            $ratingPreviewDiv.addClass("large");
            $ratingDiv.removeClass("small");
            $ratingPreviewDiv.removeClass("small");
        }
    }

    @on("change .numberInput")
    changeSurveyInput(ev) {
        let value = ev.currentTarget.value;
        let attr = $(ev.currentTarget).attr("data-attr");

        let index = $(ev.currentTarget).attr("data-index");
        let min = parseInt($(ev.currentTarget).attr("min"));
        let max = parseInt($(ev.currentTarget).attr("max"));

        if (!value.match(/\d+/)) {
            value = Math.floor((min + max) / 2);
            ev.currentTarget.value = value;
        }
        let el = $(`#rating${index} ul`);
        if (parseInt(value) < min) {
            $(ev.currentTarget).val(min);
            el.attr("data-stars", min);
            el.html("");
            this.refreshStarsPreview(el, min, index);
            value = min;
            ev.currentTarget.value = value;
        }
        if (parseInt(value) > max) {
            $(ev.currentTarget).val(max);
            el.attr("data-stars", max);
            el.html("");
            this.refreshStarsPreview(el, max, index);
            value = max;
            ev.currentTarget.value = value;
        }

        if (attr.indexOf("size") !== -1) {
            el.attr("data-stars", value);
            el.html("");
            this.refreshStarsPreview(el, value, index);
        } else {
            $(`#textarea${index}`).find("textarea").attr("max-length", value);
        }
        this.model.setNestedAttribute(attr, value);
    }

    @on("change .requiredCheckbox")
    changeRequiredCheckbox(ev) {
        let value = $(ev.currentTarget).prop("checked");
        let attr = $(ev.currentTarget).attr("data-attr");
        this.model.setNestedAttribute(attr, value);
        let index = $(ev.currentTarget).attr("data-index");
        $($(`.requiredText-${index}`)[0]).css("display", value ? "block" : "none");
        $($(`.previewRequiredText-${index}`)[0]).css("display", value ? "block" : "none");
    }

    keypress(e, self) {

    }

    textSubmit(input) {
        let pEl = $(input).closest(".edit");
        let index = pEl.data("index");
        let $2 = $(`#title-${index}`);
        switch (pEl.data("type")) {
            case "title":
                $2.text(input.val());
                break;
            case "followLink":
                break;
            case "suggestionspagetexttitleSubmit":
                $(`#surveypreviesuggestions${index}`).text(input.val());
                break;
            case "suggestionspagetexttextSubmit":
                $(`#surveypreviesuggestionsfooter${index}`).text(input.val());
                break;
            case "multiplechoicetitleSubmit":
                $(`#multipleChoiceTitle${index}`).text(input.val());
                break;
            case "multiplechoicetextSubmit":
                $(`#multipleChoiceSubTitle${index}`).text(input.val());
                break;
            case "multiplechoicesChoiceSubmit":
                $(`#choice${index}`).text(input.val());
                break;
            case "ratingTitleSubmit":
                $(`#surveyRatingTitle${index}`).text(input.val());
                break;
            case "titleText":
                $2.text(input.val());
                break;
            case "mainText":
                $(`#maintext-${index}`).text(input.val());
                break;
            case "footerText":
                $(`#footer-${index}`).text(input.val());
                break;
            case "imagetexttitleSubmit":
                $(`#surveypreviewimage${index}`).text(input.val());
                break;
            case "itemName" :
                $("#payPalItemName").text(input.val());
                break;
            case "price" :
                $("#payPalPrice").html(`&#8364; ${input.val()}`);
                break;
            case "quantity" :
                $("#payPalQuantity").html(input.val());
                break;
        }
    }

    @on('click .multipleCheckbox')
    multiplechoicesMultipleSubmit(evt) {
        let multiple = $(evt.currentTarget).prop("checked");
        let attr = $(evt.currentTarget).attr("data-attr");
        let questionIndex = $(evt.currentTarget).attr("data-index");

        let inputElPreview = $(".mchoice" + questionIndex);
        let inputElConfig = $(".configMchoice" + questionIndex);

        if (multiple) {
            inputElPreview.each(function (index, item) {
                $(item).replaceWith($("<input>", {
                        type: 'checkbox',
                        name: inputElPreview.attr('name'),
                        class: inputElPreview.attr('class')
                    })
                );
            });

            inputElConfig.each(function (index, item) {
                $(item).replaceWith($("<input>", {
                        type: 'checkbox',
                        name: inputElConfig.attr('name'),
                        class: inputElConfig.attr('class'),
                        disabled: true
                    })
                );
            });
        } else {
            inputElPreview.each(function (index, item) {
                $(item).replaceWith($("<input>", {
                        type: 'radio',
                        name: inputElPreview.attr('name'),
                        class: inputElPreview.attr('class')
                    })
                );
            });

            inputElConfig.each(function (index, item) {
                $(item).replaceWith($("<input>", {
                        type: 'radio',
                        name: inputElConfig.attr('name'),
                        class: inputElConfig.attr('class'),
                        disabled: true
                    })
                );
            });
        }
        this.qCollection.models[questionIndex].set("multiple", multiple);
        this.refreshPreview();
    }

    @on('click .enableCheckbox')
    checkBoxChange(evt) {
        let $el = $(evt.currentTarget);
        let chk = $el.prop("checked");
        let attr = $el.data("attr");
        let handler = $el.data("handler");

        this.model.setNestedAttribute(attr, chk, true);
        if (this[handler]) this[handler]($el);
    }

    changeComponentContent(contentId, componentId, isLogo) {
        if (this.model.get("campaignTemplateType") === "TELLODY_VOUCHER") return;
        this.refreshPreview();
        const image = `<img class="${isLogo ? 'logosize' : 'fullsize'}" src="/CampaignCloud/Content/LoadFileContentBytes/${contentId}">`;
        $(`#component-image-wrapper${componentId}`).html(image);
    }

    validateCondition(self) {
        if (!self.checkExpirationDate()) {
            //return if expiration date is less than the Current date.
            this.invalidFieldName =  "message.notpreviousdateavailable"
            return false;
        }
        let campaignTemplateType = this.model.get("campaignTemplateType");
        if (campaignTemplateType === "TELLODY_VOUCHER") {
            return self.toggleExecuteButtonCallback(self.isValidRedemptionRulesNumbering(), self);
        } else if (campaignTemplateType === "TELLODY_SURVEY") {
            /*
            ** validateQuestions() validates these:
            ** - hasAtLeastOneQuestion
            ** - hasAtLeastOneNonBlankLabel
            ** - multipleChoicesAtLeastTwoChoices
            ** - multipleChoiceHasBlankChoices
            ** - multipleChoiceHasBlankFields
            **
            ** validateSurvey() checks for at least one non-blank Field of: pageTitleText, pageText, footerText
            */
            return self.toggleExecuteButtonCallback(self.validateQuestions(), self);
        } else if (["EMAIL_OPTIN", "INSTANT_WIN", "QUIZ_OPTIN"].indexOf(campaignTemplateType) > -1) {
            return self.toggleExecuteButtonCallback(self.validateOptinComponents(), self);
        } else if (campaignTemplateType === 'PAY_PAL_PAYMENT') {
            return self.toggleExecuteButtonCallback(self.validateOptinComponents() && self.validatePayPalPaymentComponent(), self);
        }
        return false;
    }

    validatePayPalPaymentComponent() {
        let components = this.qCollection.models;
        let isValid = false;
        _.each(components, component => {
            if (component.get("type") === "PayPalButton") {
                if (component.get("price") &&
                    component.get("itemName") &&
                    component.get("itemName") !== i18n.t("payPalItemName") &&
                    !this.noConfiguredPaymentMethod)
                    isValid = true;
            }
        });
        if (!isValid) {
            this.invalidFieldName = "survey.payPalPaymentInfoRequired";
        }
        return isValid;
    }

    validateOptinComponents() {
        let components = this.qCollection.models;
        if (components.length === 0) {
            this.invalidFieldName = "survey.invalidOptinComponentsLength";
            return false;
        }
        let hasSocialShareComponent = _.find(components, function (component) {
            return component.get("type") === "SurveySocialFollow";
        });
        let hasAtLeastOneSetSocialFollowUrl = false;
        let containsEitherEmailOrMobile = false;
        _.each(components, function (component) {
            if (component.get("kind") === "email" || component.get("kind") === "mobile") {
                containsEitherEmailOrMobile = true;
            } else if (component.get("type") === "SurveySocialFollow") {
                let componentFollowButtons = component.get("buttons");
                hasAtLeastOneSetSocialFollowUrl = componentFollowButtons[0].url ||
                    componentFollowButtons[1].url ||
                    componentFollowButtons[2].url;
            }
        });


        if (!containsEitherEmailOrMobile) {
            this.invalidFieldName = "survey.optinEmailOrMobileRequired";
        } else if (!hasAtLeastOneSetSocialFollowUrl && hasSocialShareComponent) {
            this.invalidFieldName = "survey.invalidSurveySocialNoFollowLinks";
        }
        return ((hasAtLeastOneSetSocialFollowUrl && hasSocialShareComponent) || (!hasSocialShareComponent)) && containsEitherEmailOrMobile;
    }

    validateQuestions() {
        let questions = this.qCollection.models;
        if (this.questionsCnt === 0) {
            this.invalidFieldName = "survey.invalidSurveyQuestionsLength";
            return false;
        }
        let flag = true;
        _.each(questions, question => {
            let q = question.attributes;
            let tempInvalidField = "";
            let counter;
            switch (q.type) {
                case "SurveyStarRating":
                    if (!q.title || $.trim(q.title).length === 0)
                        tempInvalidField = "invalidSurveyStarRatingField";
                    break;
                case "SurveyFreeText":
                    if ((!q.title || $.trim(q.title).length === 0) &&
                        (!q.textQuestion || $.trim(q.textQuestion).length === 0))
                        tempInvalidField = "invalidSurveyFreeTextField";
                    break;
                case "SurveyDate":
                case "CustomFieldComponent":
                    break;
                case "CustomFieldMultipleChoiceComponent":
                    break;
                case "SurveyMultipleChoice":
                    if (q.choices.length >= 2) {
                        _.each(q.choices, function (choice) {
                            if (!choice || $.trim(choice).length === 0)
                                tempInvalidField = "invalidSurveyMultipleChoiceMC";
                        });
                    } else
                        tempInvalidField = "invalidSurveyMultipleChoiceLength";
                    if ((!q.title || $.trim(q.title).length === 0) && (!q.textQuestion || $.trim(q.textQuestion).length === 0))
                        tempInvalidField = "invalidSurveyMultipleChoiceField";
                    break;
                case "SurveyImage":
                    if (!q.imageId)
                        tempInvalidField = "invalidSurveyImageIdNA";
                    break;
                case "SurveyFormattedText":
                    if (!q.titleText && !q.mainText && !q.footerText)
                        tempInvalidField = "invalidSurveyFormattedTextEmpty";
                    break;
                case "SurveySocialFollow":
                    counter = _.countBy(q.buttons, function (button) {
                        return button.url ? 'configured' : 'empty';
                    });
                    if (!counter.configured)
                        tempInvalidField = "invalidSurveySocialNoFollowLinks";
                    break;
                case "SurveySocialShare":
                    counter = _.countBy(q.buttons, function (button) {
                        return button.active ? 'active' : 'inactive';
                    });
                    if (!counter.active)
                        tempInvalidField = "invalidSurveySocialNoNetworkSelected";
                    break;
                default:
                    console.info("Wrong question type!");
                    flag = false;

            }
            if (flag && tempInvalidField) {
                this.invalidFieldName = "survey." + tempInvalidField;
                flag = false;
            }
        });
        return flag;
    }

    execute() {
        let buttons;

        if (this.isSweepstakes) {
            if (this.model.get("endDate") === null) {
                $.Notify.show(i18n.t("instantWin.noNeverExpiration"));
                return;
            }
        }

        const alertConfig = {
            "TELLODY_SURVEY": {
                boxTitle: "survey.confirmstartsurvey",
                boxText: "survey.confirmstartsurveytext",
                alertText: "survey.surveystartsuccessfully",
                entryPoint: false
            }, "EMAIL_OPTIN": {
                boxTitle: "optin.confirmstartoptin",
                boxText: "optin.confirmstartoptintext",
                alertText: "optin.optinstartsuccessfully",
                entryPoint: true
            }, "QUIZ_OPTIN": {
                boxTitle: "optin.confirmstartquiz",
                boxText: "optin.confirmstartquiztext",
                alertText: "optin.quizstartsuccessfully",
                entryPoint: true
            }, "PAY_PAL_PAYMENT": {
                boxTitle: "confirmExecutionOfPayPalPayment",
                boxText: "confirmExecutionOfPayPalPaymentText",
                alertText: "payPalPaymentExecutedSuccessfully",
                entryPoint: true
            }, "USER_METRICS": {
                boxTitle: "instantWin.confirmStartSweepstakes",
                boxText: "instantWin.confirmStartSweepstakesText",
                alertText: "instantWin.sweepstakesStartSuccessfully",
                entryPoint: true
            }, "USER_PERCENTAGE": {
                boxTitle: "instantWin.confirmStartInstantWin",
                boxText: "instantWin.confirmStartInstantWinText",
                alertText: "instantWin.instantWinStartSuccessfully",
                entryPoint: true
            }, "NOT_ENOUGH_CONTACT_SPACE": {
                boxTitle: "profile.upgradeaccount",
                boxText: "contacts.contactlimit",
                alertText: false
            }
        };

        const campaignTemplateType = this.model.get("campaignTemplateType");
        const templateSubType = campaignTemplateType === "QUIZ_OPTIN" ? campaignTemplateType : Optional.ofNullable(this.model.get("instantWinPageConfig"))
            .map(iwpc => iwpc.get("type"))
            .orElse(campaignTemplateType);

        const {entryPoint, boxTitle, boxText, alertText} = alertConfig[templateSubType];
        if (entryPoint && !this.userModel || this.userModel.get('contactsAvailable') === 0) {
            const {boxTitle, boxText} = alertConfig["NOT_ENOUGH_CONTACT_SPACE"];
            buttons = [i18n.t("message.ok")];
            super.execute(i18n.t(boxTitle), i18n.t(boxText), i18n.t(alertText), buttons);
            return;
        }

        super.execute(i18n.t(boxTitle), i18n.t(boxText), i18n.t(alertText), buttons);
    }

    refreshPreview() {
        let el = $("#previewDiv");
        if (this.qCollection.models.length === 0) {
            el.html("");
        } else {
            let templateParams = {
                components: this.qCollection.models,
                campaignTemplateType: this.model.get("campaignTemplateType"),
                userId: this.model.get("userId"),
                campaignId: this.model.get("campaignId"),
                postPaidPrefix: this.isPostPaid ? "w" : ""
            };
            el.html(this.componentPreviewTemplate(templateParams));
            this.bindPreviewTextareaHeightEvents();
        }
        if (this.lastOpenedComponentConfig) {
            let elemToggle = $(".surveyquestionfloatingbutton" + this.lastOpenedComponentConfig);
            let elemToggleShadow = $(".surveyquestionfloatingshadow" + this.lastOpenedComponentConfig);
            this.showHideComponentInfo(elemToggle, "show");
            this.toggleVisibilityOfElement(elemToggle, "block");
            this.toggleShadowOfElement(elemToggleShadow, "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px, rgb(0, 0, 0) 0px 6px 20px 0px");
        }
    }

    @on('click .dropdown-menu > li > a')
    addComponentFromDropdown(input) {
        delete this.lastOpenedComponentConfig;

        const type = $(input.currentTarget).data("type");
        const kind = $(input.currentTarget).data("kind");
        const name = $(input.currentTarget).data("name");
        const customFieldType = $(input.currentTarget).data("custom_field_type");

        if (type.indexOf("SurveyImage") > -1) {
            this.displayContentSelector({newComponent: true, type});
        } else {
            const mutexKinds = ["email", "mobile"];
            //used to disable the insertion of `mobile` component, when `email` component is used and vice versa.
            if (mutexKinds.includes(kind)
                && this.qCollection.map(m => m.get("kind")).find(k => mutexKinds.includes(k))) {
                return;
            }

            const newModel = new ComponentModel({
                type,
                kind,
                name,
                customFieldType
            });
            this.createAndSaveComponent(newModel);
        }
    }

    async createAndSaveComponent(newModel) {
        const index = this.qCollection.models.length;
        this.qCollection.add(newModel);
        const srvModel = jQuery.extend(true, {}, newModel);
        srvModel.unset("type", {silent: true});
        srvModel.unset("name", {silent: true});
        if (newModel.get("type") === "CustomFieldMultipleChoiceComponent" && newModel.get("customFieldType") === "multipleChoice") {
            const custom_field_id = newModel.get("kind").replace(/[^0-9.]+/g, "");

            this.customFields.filter(customField => customField.type === "multipleChoice").forEach(customField => {
                if (customField.id === custom_field_id) {
                    const values = customField.values.split(",");
                    newModel.set("choices", values);
                }
            });
        }

        const data = `object:com.msensis.campaign.guicoreintegration.model.SurveyPageConfig$${newModel.get("type")}:${JSON.stringify(srvModel)}`;
        try {
            await $.ajaxDefaultQ({
                url: `/CampaignCloud/Config/${this.model.get("id")}/surveyPageConfig.components/${index}`,
                type: 'PUT',
                data,
                contentType: "text/plain",
                dataType: "json"
            });
            const params = _.extend({
                cind: index,
                campaignId: this.model.get("campaignId"),
                campaignTemplateType: this.model.get("campaignTemplateType"),
                userId: this.model.get("userId"),
                postPaidPrefix: this.isPostPaid ? "w" : "",
                endDate: this.model.get("endDate")
            }, this.qCollection.at(index).attributes);
            $("#componentRows").append(this.ComponentRowTemplate(params));
            this.refreshPreview();
            this.rewireEvents({low: index, high: index});

            if (this.isQuestion(newModel.get("type"))) {
                $.Notify.show(i18n.t("survey.questioncreated"));
                this.questionsCnt++;
            } else {
                $.Notify.show(i18n.t("survey.componentcreated"));
                this.flag = true;
            }
            this.validateCondition(this);
            this.hideFields(this);

        } catch (e) {
            console.info(e);
            $.Notify.error("An error occurred!");
            this.qCollection.models.splice(index, 1);
        }
    }

    getFacebookShareCount(url) {
        $.ajaxDefaultQ({
            url: "/CampaignCloud/oauthClient/getFacebookShares",
            type: 'POST',
            data: {url}
        }).done(function (response) {
            let data = JSON.parse(response);
            if (!data.hasOwnProperty('error') && data.share)
                $("#fb-shares").text(data.share.share_count);
        });
    }

    @on('click .remove')
    async removeComponent(event) {
        try {
            let index = $(event.currentTarget).attr("data-index");
            await this.model.batchUpdate();
            const result = await dhtmlx.modalbox({
                title: i18n.t("survey.confirmdeletion"),
                text: i18n.t("survey.areyousuretodelete"),
                buttons: [i18n.t("message.yes"), i18n.t("message.no")]
            });
            if (result === "0") {
                await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Config/${this.model.get("id")}/surveyPageConfig.components/${index}`,
                    type: 'DELETE',
                    dataType: 'json'
                });
                let removed = this.qCollection.remove(this.qCollection.models[index]);
                let compRows = $("#componentRows").find('.questionLi');
                let i;
                for (i = parseInt(index); i < compRows.length - 1; i++) {
                    let params = _.extend({
                        cind: i,
                        campaignId: this.model.get("campaignId"),
                        campaignTemplateType: this.model.get("campaignTemplateType"),
                        userId: this.model.get("userId"),
                        postPaidPrefix: this.isPostPaid ? "w" : "",
                        endDate: this.model.get("endDate")
                    }, this.qCollection.at(i).attributes);
                    $(compRows.get(i))
                        .replaceWith(this.ComponentRowTemplate(params));
                }
                $(compRows.get(i)).remove();
                if (this.isQuestion(removed.get("type"))) {
                    $.Notify.show(i18n.t("survey.questionremoved"));
                    this.questionsCnt--;
                    if (this.questionsCnt === 0) {
                        $.Notify.error(i18n.t("survey.atleastonequestion"));
                        this.flag = false;
                    }
                } else
                    $.Notify.show(i18n.t("survey.componentremoved"));
                this.refreshPreview();
                this.validateCondition(this);
                this.hideFields(this);

            }
        } catch (e) {
            console.info(e);
            $.Notify.error("An error occurred!");
        }

    }

    /*
     * Method for hiding the optin fields that are already added.
     */
    hideFields(ref) {
        let self = ref || this;
        let tempType = self.model.get("campaignTemplateType");
        if (tempType === "EMAIL_OPTIN" || tempType === "QUIZ_OPTIN" || tempType === "INSTANT_WIN" || tempType === "PAY_PAL_PAYMENT" || tempType === "TELLODY_SURVEY") {
            let i = 0; // Counts the fields with kind in optin.
            let $dropdown = $(".dropdown-menu");
            $dropdown.find('[data-kind], [data-type]').parent().show();

            //clear "disabled" style of mobile/email, to ensure that no "disabled" style will appear, even if it can used.
            $dropdown.find('[data-kind="email"]').removeClass("bg-grayLight").removeClass("fg-emerald").removeClass("cursorNotAllowed").addClass("bg-white").addClass("fg-funkyOrange");
            $dropdown.find('[data-kind="mobile"]').removeClass("bg-grayLight").removeClass("fg-emerald").removeClass("cursorNotAllowed").addClass("bg-white").addClass("fg-funkyOrange");
            $dropdown.find('[data-kind="email"]').parent().removeAttr("title");
            $dropdown.find('[data-kind="mobile"]').parent().removeAttr("title");

            self.qCollection.each(function (model) {
                // Hiding the corresponding kind from dropdown menu in order to not add duplicate fields.
                let $dropdown2 = $(".dropdown-menu");
                if (model.has('kind')) {
                    //hide `mobile` when `email` is used and vice versa
                    if (model.get('kind') === "email") {
                        //disable `email` and enable `mobile`
                        $dropdown2.find('[data-kind="email"]').removeClass("bg-grayLight").removeClass("fg-emerald").removeClass("cursorNotAllowed").addClass("bg-white").addClass("fg-funkyOrange");
                        $dropdown2.find('[data-kind="mobile"]').removeClass("bg-white").removeClass("fg-funkyOrange").addClass("cursorNotAllowed").addClass("bg-grayLight").addClass("fg-emerald");

                        $dropdown2.find('[data-kind="mobile"]').parent().attr("title", i18n.t("optin.removeEmailToUseMobile"));
                        $dropdown2.find('[data-kind="email"]').parent().removeAttr("title");
                    } else if (model.get('kind') === "mobile") {
                        //disable `mobile` and enable `email`
                        $dropdown2.find('[data-kind="mobile"]').removeClass("bg-grayLight").removeClass("fg-emerald").removeClass("cursorNotAllowed").addClass("bg-white").addClass("fg-funkyOrange");
                        $dropdown2.find('[data-kind="email"]').removeClass("bg-white").removeClass("fg-funkyOrange").addClass("cursorNotAllowed").addClass("bg-grayLight").addClass("fg-emerald");

                        $dropdown2.find('[data-kind="email"]').parent().attr("title", i18n.t("optin.removeMobileToUseEmail"));
                        $dropdown2.find('[data-kind="mobile"]').parent().removeAttr("title");
                    }
                    if (model.get('kind') !== "address" && model.get('kind') !== "") {
                        $dropdown2.find("[data-kind='" + model.get('kind') + "']").parent().hide();
                    }
                    i++;
                } else if (/^SurveySocial/.test(model.get('type'))) {
                    $dropdown2.find("[data-type='" + model.get('type') + "']").parent().hide();
                    i++;
                }
            });
        }
    }

    async setSurveyScore() {
        let self = this;
        try {
            const data = await $.ajaxDefaultQ({
                url: `/CampaignCloud/Report/${self.model.get("campaignId")}/getAverageOfStarRatingForCampaign`,
                type: 'GET',
                dataType: 'json'
            });
            if (!data[0]) {
                self.$("#surveyScore").text("-");
            } else {
                const score = (data[0].averageRating * 100).toFixed(0) + "%";
                self.$("#surveyScore").text(score);
            }

        } catch (e) {
            console.error(e);
        }
    }

    @on('click .addMCAnswer')
    async addMCAnswer(input) {
        let questionIndex = $(input.currentTarget).attr("data-index");
        let questionsEl = this.qCollection.models[questionIndex].get("choices");
        let index = questionsEl.length;

        questionsEl.push(" ");

        let data = questionsEl[index];

        try {
            await $.ajaxDefaultQ({
                url: `/CampaignCloud/Config/${this.model.get("id")}/surveyPageConfig.components[${questionIndex}].choices/${index}`,
                type: 'PUT',
                data,
                contentType: "text/plain",
                dataType: "json"
            });
            let params = _.extend({
                cind: questionIndex,
                campaignId: this.model.get("campaignId"),
                campaignTemplateType: this.model.get("campaignTemplateType"),
                userId: this.model.get("userId"),
                postPaidPrefix: this.isPostPaid ? "w" : "",
                endDate: this.model.get("endDate")
            }, this.qCollection.at(questionIndex).attributes);
            $(`#component-${questionIndex}`).replaceWith(this.ComponentRowTemplate(params));
            this.refreshPreview();
            this.rewireEvents({low: questionIndex, high: questionIndex});

        } catch (e) {
            console.info(e);
            $.Notify.error("An error occurred!");
        }
    }

    //TODO incorporate in deleteRow
    @on('click .deleteMCAnswer')
    async deleteMCAnswer(input) {
        let questionIndex = $(input.currentTarget).attr("data-parent-index");
        let index = $(input.currentTarget).attr("data-index");
        let questionsEl = this.qCollection.models[questionIndex].get("choices");
        if (questionsEl.length === 2) {
            $.Notify.error(i18n.t("survey.atleasttwochoices"));
            return;
        }
        await this.model.batchUpdate();
        try {
            const result = await dhtmlx.modalbox({
                title: i18n.t("survey.confirmdeletion"),
                text: i18n.t("survey.areyousuretodelete"),
                buttons: [i18n.t("message.yes"), i18n.t("message.no")]
            });
            if (result === "0") {
                await $.ajaxDefaultQ({
                    url: `/CampaignCloud/Config/${this.model.get("id")}/surveyPageConfig.components[${questionIndex}].choices/${index}`,
                    type: 'DELETE',
                    dataType: 'json'
                });
                $.Notify.show(i18n.t("survey.choiceremoved"));
                this.qCollection.models[questionIndex].get("choices").splice(index, 1);
                let params = _.extend({
                    cind: questionIndex,
                    campaignId: this.model.get("campaignId"),
                    campaignTemplateType: this.model.get("campaignTemplateType"),
                    userId: this.model.get("userId"),
                    postPaidPrefix: this.isPostPaid ? "w" : "",
                    endDate: this.model.get("endDate")
                }, this.qCollection.at(questionIndex).attributes);
                $(`#component-${questionIndex}`).replaceWith(this.ComponentRowTemplate(params));
                this.refreshPreview();
                this.rewireEvents({low: questionIndex, high: questionIndex});
            }

        } catch (e) {
            console.info(e);
            $.Notify.error("An error occurred!");
        }
    }

    urlIsValid(input) {
        $(input).removeClass("invalid").addClass("valid");
    }

    urlIsInvalid(input) {
        $(input).removeClass("valid").addClass("invalid");
    }

    urlSubmit(input) {
        return !input.hasClass('invalid');
    }

    @on('click .deleteShareButton')
    async deleteRow(input) {
        const currTrg = $(input.currentTarget);
        const componentIndex = currTrg.data("parent-index");
        const index = currTrg.data("index");
        const attributeName = currTrg.data("name");
        const el = this.qCollection.models[componentIndex][attributeName];
        const url = `/CampaignCloud/Config/${this.model.get("id")}/surveyPageConfig.components[${componentIndex}].${attributeName}/${index}`;

        const result = await dhtmlx.modalbox({
            title: i18n.t("survey.confirmdeletion"),
            text: i18n.t("survey.areyousuretodelete"),
            buttons: [i18n.t("message.yes"), i18n.t("message.no")]
        });
        if (result === "0") {
            try {
                await $.ajaxDefaultQ({
                    url,
                    type: 'DELETE',
                    dataType: 'json'
                });
                $.Notify.show(i18n.t("survey.elementremoved"));
                el.splice(index, 1);
                this.refreshPreview();

            } catch (e) {
                console.info(e);
                $.Notify.error("An error occurred!");
            }
        }
    }

    tabTextSubmit(input) {
        let $currentTarget = $(input[0]);
        let value = $currentTarget.val();
        let attributeName = $currentTarget.parent().parent().data("id");
        console.info($currentTarget);
        $(`[id="${attributeName}"]`).text(value);
    }

    rulesFooterNoteSubmit(input) {
        let $currentTarget = $(input[0]);
        let value = CKEDITOR.instances["wysiwyg-editable"].getData();
        let attributeName = $currentTarget.attr("id");
        $(`[id="${attributeName}"]`).html(value);
    }

    @on('click .surveyContainerDiv')
    checkAndCloseOpenedComponentInfo() {
        let self = this;
        let elemsToClose = $(".surveyComponentCloseButton:visible");
        this.lastOpenedComponentConfig = null;
        $.each(elemsToClose, function (index, element) {
            self.showHideComponentInfo($(element), "hide");
        });
    }

    submitWinRule(input) {
        let winType = this.model.get("instantWinPageConfig").get("type"); //`USER_PERCENTAGE` => Instant Win, `USER_METRICS` => Sweepstakes
        let valueToSave = parseInt(input.val());

        switch (winType) {
            case "USER_PERCENTAGE":
                if (valueToSave <= 0 || valueToSave > 100) {
                    $.Notify.error(i18n.t("instantWin.minimumMaximumValueExceeded"));
                    return false;
                }
                break;
            case "USER_METRICS":
                if (valueToSave <= 0) {
                    $.Notify.error(i18n.t("instantWin.minimumValueExceeded"));
                    return false;
                }
                break;
        }
        return undefined;
    }

    decimalIsValid(e, input) {
        $(input).removeClass("invalid").addClass("valid");
        let message = $(e).next("span");
        message.empty();
        message.hide();
    }

    decimalIsInvalid(e, input) {
        let message = $(e).next("span");
        let decimals = $(e).data("decimals");
        let integer = decimals === 0;
        message.text(i18n.t(integer ? "customFieldIntegerTypeError" : "customFieldDecimalTypeError"));
        message.css("display", "block");
        $(input).removeClass("valid").addClass("invalid");
    }

    decimalSubmit(input) {
        this.textSubmit(input);
        return input.hasClass('valid');
    }

    decimalBlur() {
        $('#error-decimal').empty();
        return true;
    }

    quantityBlur() {
        $('#error-quantity').empty();
        return true;
    }
}

export default ServiceView;
